import React, { createContext, useContext } from 'react';
import { describeXeroInvoicesConfig } from '../config/xeroInvoicesConfig';
import { useXeroInvoicesRuntimeFlags } from '../hooks/useXeroInvoicesRuntimeFlags';

const XeroInvoicesFlagsContext = createContext(null);

/**
 * Hydrates Firestore Xero UI flags and re-renders the SPA tree when they change
 * so sync gate helpers (isXeroInvoices*SurfaceEnabled) stay current.
 */
export function XeroInvoicesFlagsProvider({ children }) {
  const cfg = useXeroInvoicesRuntimeFlags();
  return (
    <XeroInvoicesFlagsContext.Provider value={cfg}>
      {children}
    </XeroInvoicesFlagsContext.Provider>
  );
}

export function useXeroInvoicesFlags() {
  const ctx = useContext(XeroInvoicesFlagsContext);
  return ctx || describeXeroInvoicesConfig();
}
